// 📁 src/components/account/modules/AuditReadyModule.jsx

import React, { useEffect, useState } from 'react';

export default function AuditReadyModule() {
  const [companyName, setCompanyName] = useState('');
  const [tenantId, setTenantId] = useState('');

  useEffect(() => {
    const email = localStorage.getItem('email');
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    const account = registry[email] || {};
    setCompanyName(account.companyName || '');
    setTenantId(account.tenantId || '');

    const auditLog = JSON.parse(localStorage.getItem(`paymentAuditLog_${email}`) || '[]');
    const accessEntry = auditLog.find((entry) => entry.moduleName === 'AuditReady');
    const isPaid = accessEntry?.paymentStatus === 'paid' && accessEntry?.status === 'active';

    if (!isPaid) {
      alert('Access to AuditReady is denied. Please complete payment.');
    }
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-2">AuditReady Suite</h2>
      {(companyName || tenantId) && (
        <div className="mb-4 text-sm text-gray-600 italic">
          {companyName && <div>Company Name: {companyName}</div>}
          {tenantId && <div>Tenant ID: {tenantId}</div>}
        </div>
      )}
      <p className="text-gray-600">
        This is a placeholder for the compliance and audit trail management interface.
      </p>
    </div>
  );
}
